import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-2" }
const _hoisted_2 = {
  class: "block",
  for: "spaceName"
}
const _hoisted_3 = { class: "flex gap-4 flex-col items-start md:flex-row md:justify-between md:items-center" }
const _hoisted_4 = { class: "text-2xl" }
const _hoisted_5 = {
  key: 0,
  class: "border rounded shadow"
}
const _hoisted_6 = { class: "w-full bg-gray-200 p-2 font-medium" }
const _hoisted_7 = { class: "flex flex-wrap gap-2" }
const _hoisted_8 = {
  class: "block",
  for: "newTableName"
}
const _hoisted_9 = {
  class: "block",
  for: "newTableMaximumCapacity"
}
const _hoisted_10 = { class: "flex justify-end gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "flex-shrink flex-grow-0"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex gap-x-2" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex justify-end gap-2" }

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import CButton from "@/components/Button.vue";
import inputText from "primevue/inputtext";
import { ref } from "vue";
import { cloneDeep } from "lodash";
import { useVuelidate } from "@vuelidate/core";
import FormErrors from "@/components/FormErrors.vue";
import { useStore } from "vuex";
import { useConfirm } from "primevue/useconfirm";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'SpaceForm',
  props: {
  space: {
    type: Object,
    default: () => ({}),
  },
  isUpdate: {
    type: Boolean,
    default: false,
  },
},
  emits: ["cancel", "save"],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n();

const store = useStore();




const confirm = useConfirm();
const spaceRules = props.isUpdate
  ? store.getters["space/rulesToUpdateASpace"]
  : store.getters["space/rulesToCreateASpace"];
const updateTableListRules = store.getters["space/rulesToUpdateATableList"];
const newTableRules = store.getters["space/rulesToCreateATable"];

let space = ref();
let tables = ref();
let newTable = ref();
let spaceV$: any;
let tableListV$: any;
let newTableV$: any;
const isShowNewTableForm = ref(false);

const showNewTableForm = (value: boolean) => {
  isShowNewTableForm.value = value;
};
const resetNewTable = () => {
  newTable.value = {};
  newTableV$.value.$reset();
};
const init = () => {
  spaceV$ = useVuelidate(spaceRules, space, { $lazy: true });
  tableListV$ = useVuelidate(updateTableListRules, tables);
  newTableV$ = useVuelidate(newTableRules, newTable);
  showNewTableForm(false);
  resetNewTable();
  space.value = cloneDeep(props.space);
  tables.value = (space.value?.tables ?? []).map((table: any) => {
    table.isUpdating = false;
    return table;
  });
};

init();

const save = async () => {
  const isSpaceValid = await spaceV$.value.$validate();
  const isTableListValid = await tableListV$.value.$validate();
  if (isSpaceValid && isTableListValid) {
    space.value.tables = tables.value.map((table: any) => ({
      id: table.id,
      name: table.name,
      maximumCapacity: table.maximumCapacity,
    }));
    emit("save", cloneDeep(space.value));
  }
};
const cancel = () => {
  init();
  emit("cancel");
};
const addATable = async () => {
  if (await newTableV$.value.$validate()) {
    newTable.value.isUpdate = false;
    tables.value.push(cloneDeep(newTable.value));
    resetNewTable();
    showNewTableForm(false);
  }
};
const cancelAddingATable = () => {
  resetNewTable();
  showNewTableForm(false);
};
const deleteTable = (index: number) => {
  confirm.require({
    message: `${t("deletingTable")} ${tables.value[index].name ?? ""}`,
    header: t("confirmation"),
    icon: "pi pi-exclamation-triangle",
    accept: () => {
      tables.value.splice(index, 1);
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "flex flex-col gap-y-4",
    onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("spaceName")), 1),
        _createVNode(_unref(inputText), {
          id: "spaceName",
          type: "text",
          modelValue: _unref(spaceV$).name.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(spaceV$).name.$model) = $event)),
          autocomplete: "off",
          class: _normalizeClass({ 'p-invalid': _unref(spaceV$).name.$invalid })
        }, null, 8, ["modelValue", "class"]),
        _createVNode(FormErrors, {
          errors: _unref(spaceV$).name.$errors
        }, null, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("tables")), 1),
        _createVNode(CButton, {
          class: _normalizeClass(["p-button-xs", { invisible: isShowNewTableForm.value }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showNewTableForm(true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("addATable")), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createVNode(_Transition, { name: "toggleable-content" }, {
        default: _withCtx(() => [
          (isShowNewTableForm.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("addATable")), 1),
                _createElementVNode("form", {
                  onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
                  class: "p-5"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("tableName")), 1),
                      _createVNode(_unref(inputText), {
                        id: "newTableName",
                        modelValue: _unref(newTableV$).name.$model,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(newTableV$).name.$model) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(FormErrors, {
                        errors: _unref(newTableV$).name.$errors
                      }, null, 8, ["errors"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("maximumCapacity")), 1),
                      _createVNode(_unref(inputText), {
                        type: "number",
                        min: 0,
                        modelValue: _unref(newTableV$).maximumCapacity.$model,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(newTableV$).maximumCapacity.$model) = $event)),
                        class: "w-40"
                      }, null, 8, ["modelValue"]),
                      _createVNode(FormErrors, {
                        errors: _unref(newTableV$).maximumCapacity.$errors
                      }, null, 8, ["errors"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(CButton, {
                      class: "p-button-xs p-button-success",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (addATable()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("add")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(CButton, {
                      class: "p-button-xs p-button-danger",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (cancelAddingATable()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 32)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_unref(DataTable), {
        value: _unref(tables),
        responsiveLayout: "stack",
        breakpoint: "650px"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: "name",
            header: _ctx.$t('tableName')
          }, {
            body: _withCtx(({ data, index }) => [
              (data.isUpdating)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_unref(inputText), {
                      modelValue: data.name,
                      "onUpdate:modelValue": ($event: any) => ((data.name) = $event),
                      class: "w-full md:w-auto"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(FormErrors, {
                      errors: _unref(tableListV$).$each?.$response?.$errors[index]['name']
                    }, null, 8, ["errors"])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(data.name), 1))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            field: "maximumCapacity",
            header: _ctx.$t('maximumCapacity')
          }, {
            body: _withCtx(({ data, index }) => [
              (data.isUpdating)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_unref(inputText), {
                      type: "number",
                      min: 0,
                      modelValue: data.maximumCapacity,
                      "onUpdate:modelValue": ($event: any) => ((data.maximumCapacity) = $event),
                      class: "w-20"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(FormErrors, {
                      errors: 
                  _unref(tableListV$).$each?.$response?.$errors[index][
                    'maximumCapacity'
                  ]
                
                    }, null, 8, ["errors"])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(data.maximumCapacity), 1))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_unref(Column), {
            header: _ctx.$t('action')
          }, {
            body: _withCtx(({ data, index }) => [
              _createElementVNode("div", _hoisted_15, [
                (!data.isUpdating)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "pi pi-pencil hover:cursor-pointer",
                      onClick: ($event: any) => (data.isUpdating = true)
                    }, null, 8, _hoisted_16))
                  : _createCommentVNode("", true),
                _createElementVNode("i", {
                  class: "pi pi-trash hover:cursor-pointer",
                  onClick: ($event: any) => (deleteTable(index))
                }, null, 8, _hoisted_17)
              ])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(CButton, {
        class: "p-button-xs p-button-success",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (save()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
        ]),
        _: 1
      }),
      _createVNode(CButton, {
        class: "p-button-xs p-button-danger",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (cancel()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
        ]),
        _: 1
      })
    ])
  ], 32))
}
}

})